import React from 'react';
import reproductive from '../assets/Reproductive.png';
import { Link } from 'react-router-dom';
const Reproductive = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-pink-50 py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-7xl mx-auto">
        
        {/* Main Content Card */}
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-pink-100 flex flex-col lg:flex-row items-center">
          
          {/* Image Section - Left/Top */}
          <div className="lg:w-1/2 p-8 bg-white flex justify-center items-center relative">
            {/* Soft Glow Background behind image */}
            <div className="absolute inset-0 bg-pink-100 opacity-20 blur-3xl rounded-full scale-75"></div>
            
            <img 
              src={reproductive}
              alt="Anion Technology and Reproductive Health"
              className="relative z-10 w-full h-auto max-w-md transform transition duration-500 hover:scale-105"
            />
          </div>

          {/* Content Section - Right/Bottom */}
          <div className="lg:w-1/2 p-8 lg:p-16">
            <span className="inline-block px-3 py-1 rounded-full bg-pink-100 text-pink-600 text-xs font-bold uppercase tracking-wider mb-4">
              Biotech Wellness
            </span>
            <h1 className="text-4xl font-extrabold text-gray-900 leading-tight mb-6">
              Protection That Goes <br />
              <span className="text-pink-600 underline decoration-pink-200">Beyond the Surface</span>
            </h1>
            
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Standard pads only catch what leaves your body. Our technology is designed to 
              support your reproductive health while you wear it, creating a protective 
              environment that promotes internal balance and lasting freshness.
            </p>

            {/* Feature List */}
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800">Active Anion Release</h3>
                  <p className="text-gray-500">The pink core chip releases negative ions that travel upward, neutralizing odors and inhibiting bacterial growth at the source.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-pink-100 flex items-center justify-center text-pink-600">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800">Circulatory Harmony</h3>
                  <p className="text-gray-500">Designed to support natural energy flow, helping to soothe discomfort and reduce the feeling of inflammation during your cycle.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-600">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <div className='mb-10'> 
                  <h3 className="text-lg font-bold text-gray-800 ">pH Balanced Environment</h3>
                  <p className="text-gray-500">Breathable layers ensure oxygen reaches your skin, maintaining the delicate acidic balance of your reproductive system.</p>
                </div>
              </div>
            </div>

            <Link to="/products" className="mt-10 w-full sm:w-auto px-8 py-4 bg-pink-600 hover:bg-pink-700 text-white font-bold rounded-xl shadow-lg shadow-pink-200 transition-all duration-300 transform hover:-translate-y-1">
              Experience Total Wellness
            </Link>
          </div>
        </div>

        {/* Bottom Social Proof/Trust section */}
        <div className="mt-12 flex flex-wrap justify-center gap-8 text-gray-400 font-medium">
          <div className="flex items-center gap-2">✓ Gynecologist Recommended</div>
          <div className="flex items-center gap-2">✓ Oxygen-Permeable Layers</div>
          <div className="flex items-center gap-2">✓ 24-Hour Odor Protection</div>
        </div>

      </div>
    </div>
  );
};

export default Reproductive;